// ==============================|| COUPLE ICON ||============================== //

const CoupleIcon = ({ color = '#3b66b0', width = 24, className = '' }) => {
  const commonStyle = {
    fill: color,
    strokeWidth: '0px',
  };

  return (
    <svg
      width={width}
      height={width}
      viewBox="0 0 41.1 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <rect
        x="7.2"
        y="14.1"
        width="31.2"
        height="1.8"
        style={commonStyle}
      />
      <path
        d="M2.3,18.6H1c-.5,0-.8.4-.8.8v.2c0,.5.4.8.8.8h1.3v-1.9h0Z"
        style={commonStyle}
      />
      <path
        d="M39.4,15.8H2c-.5,0-.8.4-.8.8v5.2c0,.5.4.8.8.8h2.9c.1-4,3.2-6.5,6.4-6.5s6.4,2.9,6.4,6.4h0s2.1,0,2.1,0c.1-4,3.1-6.4,6.4-6.4s6.4,2.9,6.4,6.4h0s1.9,0,1.9,0h3.8s1.2,0,1.2,0v-6.9h0Z"
        style={commonStyle}
      />
      <path
        d="M26.2,17.1c-3,0-5.5,2.5-5.5,5.5s2.5,5.5,5.5,5.5,5.5-2.5,5.5-5.5-2.5-5.5-5.5-5.5ZM26.2,24.3c-1,0-1.7-.8-1.7-1.7s.8-1.7,1.7-1.7,1.7.8,1.7,1.7-.8,1.7-1.7,1.7Z"
        style={commonStyle}
      />
      <path
        d="M11.2,17.1c-3,0-5.5,2.5-5.5,5.5s2.5,5.5,5.5,5.5,5.5-2.5,5.5-5.5-2.5-5.5-5.5-5.5ZM11.2,24.3c-1,0-1.7-.8-1.7-1.7s.8-1.7,1.7-1.7,1.7.8,1.7,1.7-.8,1.7-1.7,1.7Z"
        style={commonStyle}
      />
      <circle
        cx="18.3"
        cy="10.4"
        r="2.7"
        style={commonStyle}
      />
      <rect
        x="1.8"
        y="6"
        width="37.3"
        height="2.2"
        rx="1"
        ry="1"
        transform="translate(2.8 -5.5) rotate(16.3)"
        style={commonStyle}
      />
    </svg>
  );
};

export default CoupleIcon;
